import { fetchWithAuth } from "@/lib/http";

const API_BASE = "/api";

export class ApiError extends Error {
  status?: number;
  detail?: unknown;

  constructor(message: string, status?: number, detail?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.detail = detail;
  }
}

const jsonHeaders = { "Content-Type": "application/json" };

export interface CreateGroupRequest {
  name: string;
  order?: number;
}

export interface UpdateGroupRequest {
  // 兼容后端可能使用不同的标识字段
  app_id?: string;
  id?: string;
  name?: string;
  order?: number;
  removed?: boolean;
}

async function parseError(res: Response) {
  const status = res.status;
  let payload: unknown = null;
  try {
    payload = (await res.json()) as unknown;
  } catch {
    try {
      payload = await res.text();
    } catch {
      payload = null;
    }
  }
  let message = `请求失败: ${status}`;
  if (payload && typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    const detail = record.detail;
    const error = record.error;
    if (typeof detail === "string" && detail.trim()) message = detail;
    else if (typeof error === "string" && error.trim()) message = error;
  }
  return new ApiError(message, status, payload);
}

export async function createGroup(input: CreateGroupRequest) {
  const res = await fetchWithAuth(`${API_BASE}/group/create`, {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({
      name: input.name,
      order: typeof input.order === "number" ? input.order : 0,
    }),
  });

  if (!res.ok) throw await parseError(res);
  return await res.json();
}

export async function updateGroup(input: UpdateGroupRequest) {
  const res = await fetchWithAuth(`${API_BASE}/group/update`, {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(input),
  });

  if (!res.ok) throw await parseError(res);
  return await res.json();
}

export async function deleteGroup(appId: string) {
  const res = await fetchWithAuth(`${API_BASE}/applications/${appId}`, {
    method: "DELETE",
  });

  if (!res.ok) throw await parseError(res);
  return await res.json();
}
